type Listener = () => void;

let isLoading = false;
const listeners = new Set<Listener>();

const getSnapshot = () => isLoading;

const setLoading = (nextIsLoading: boolean) => {
  if (isLoading === nextIsLoading) {
    return;
  }

  isLoading = nextIsLoading;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: Listener) => {
  listeners.add(listener);

  return () => listeners.delete(listener);
};

export const assistantInterestContextLoadingStore = {getSnapshot, setLoading, subscribe};
